import { render, staticRenderFns } from "./Join Us.vue?vue&type=template&id=5bdff408&scoped=true&"
import script from "./Join Us.vue?vue&type=script&lang=js&"
export * from "./Join Us.vue?vue&type=script&lang=js&"
import style0 from "./Join Us.vue?vue&type=style&index=0&id=5bdff408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdff408",
  null
  
)

export default component.exports